import Modal from './Modal'

export { Modal }
export default Modal
